import "../../styles/Modal.css"

import ManagerEditForm from "../forms/ManagerEditForm"

function ManagerEditModal({ onClose }) {

  return (
    <div className="m-overlay" >

      <div className="sm-content" >
        <div className="m-header" >
          <h4 className="m-title">Edit Manager</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="ma-body" >
          <ManagerEditForm />
        </div>

        <div className="sm-footer" >
          <button className="m-cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>

    </div>
  )
}

export default ManagerEditModal
